export const confirmAction = (message) => {
  return window.confirm(message);
};
